// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon_WeLsZ {
  height: 100%;
  width: 100%;
  color: var( --light-grey );
}

.container_REanJ {
  overflow-y: auto;
  height: ~'calc( 100% - 40px )';
}`, "",{"version":3,"sources":["webpack://./src/editors/timer/style.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC","sourcesContent":["@import \"../../style/theme.css\";\n\n.icon {\n  height: 100%;\n  width: 100%;\n  color: var( --light-grey );\n}\n\n.container {\n  overflow-y: auto;\n  height: ~'calc( 100% - 40px )';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `icon_WeLsZ`,
	"container": `container_REanJ`
};
export default ___CSS_LOADER_EXPORT___;
